import { createReducer, on } from "@ngrx/store";
import * as actionShell from './state.actions';
import { initialState } from "./../../../app.state";

export const actionShellReducer = createReducer(
  initialState,
  on(actionShell.setProgreesBar, (state, { progressBar }) => ({ ...state, progressBar })),
  on(actionShell.setLoadInitial, (state, { loadInitial }) => ({ ...state, loadInitial })),

);